import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../api/auth';
import toast from 'react-hot-toast';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await forgotPassword({ email });
      setSent(true);
      toast.success('Check your email for reset instructions');
    } catch {
      setSent(true); // Don't reveal if email exists
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="w-full max-w-md text-center bg-white rounded-xl shadow-sm border border-dark-200 p-8">
          <div className="text-4xl mb-4">&#9993;</div>
          <h2 className="text-xl font-bold text-dark-800 mb-2">Check your email</h2>
          <p className="text-dark-400 text-sm mb-6">If an account exists for {email}, we've sent password reset instructions.</p>
          <Link to="/login" className="text-primary-500 hover:text-primary-600 font-medium text-sm">Back to login</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-primary-500">WhatsApp SaaS</h1>
          <p className="text-dark-400 mt-2">Reset your password</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-sm border border-dark-200 p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-dark-700 mb-1">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2.5 border border-dark-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none text-sm"
              placeholder="you@example.com" />
          </div>
          <button type="submit" disabled={loading}
            className="w-full bg-primary-500 text-white py-2.5 rounded-lg font-medium hover:bg-primary-600 disabled:opacity-50 transition-colors text-sm">
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
          <p className="text-center text-sm text-dark-400">
            <Link to="/login" className="text-primary-500 hover:text-primary-600 font-medium">Back to login</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
